export const DISCOUNT_LAYER = {
  BASE: 'base',
  PROMO: 'promo',
  PICKUP: 'pickup',
  BONUSES: 'bonuses',
};

export const PRODUCT_TYPE = {
  COMBO: 'combo',
  PROMOTIONAL: 'promotional',
  REGULAR: 'regular',
};

// Frontend defaults for discount eligibility by product type.
// Will be replaced or merged with backend rules when available.
export const DEFAULT_PRODUCT_TYPE_DISCOUNT_RULES = {
  [PRODUCT_TYPE.COMBO]: {
    eligibleForPickup: false,
    eligibleForBonuses: false,
    eligibleForPromocodeStack: true,
  },
  [PRODUCT_TYPE.PROMOTIONAL]: {
    eligibleForPickup: false,
    eligibleForBonuses: false,
    eligibleForPromocodeStack: true,
  },
  [PRODUCT_TYPE.REGULAR]: {
    eligibleForPickup: true,
    eligibleForBonuses: true,
    eligibleForPromocodeStack: true,
  },
};

// Composition item types excluded from generic composition totals.
export const DEFAULT_EXCLUDED_COMPOSITION_TYPES = ['pizza_box'];

// Non-regular cart lines excluded from pickup and bonus discount bases.
export const REGULAR_DISCOUNT_EXCLUDED_COMPOSITION_TYPES = [
  'pizza_box',
  'combo',
  'promotional',
  'gift',
  'bonus',
  'upsale',
];

/** @deprecated use REGULAR_DISCOUNT_EXCLUDED_COMPOSITION_TYPES */
export const PICKUP_EXCLUDED_COMPOSITION_TYPES = REGULAR_DISCOUNT_EXCLUDED_COMPOSITION_TYPES;
